export const observation = {
  name_one: "observation",
  name_other: "observations",
  observationDate: "Date d'observation",
  observationDateColumn: "Date \n d'observation",
  concernedAsset: "Actif concerné",
  assetType: "Type d'actif",
  createdBy: "Créé par",
  id: "Id",
  name: "Nom",
  risk: {
    label: "Risque",
    low: "Faible",
    moderate: "Modéré",
    high: "Élevé",
    critical: "Critique",
    none: "Aucun",
  },
  sourceIntervention: "Intervention source",
  sourceObservationLink:
    "Naviguer vers la section de l'observation dans l'intervention source",
  sourceInterventionStateColumn: "État de \n l'intervention source",
  recommendedInterventions: {
    title: "Recommandations",
  },
  dueDays: "Délai maximal d'intervention",
  images: "Photos ({{count}})",
  noImage: "Aucune photo",
  position: "Position",
  noPosition: "Aucune position",
  users: "Utilisateurs",
  description: "Description",
  summary: "Sommaire",
  severity: "Sévérité",
  source: {
    probability: "Probabilité",
    consequence: "Conséquence",
    component: "Composant",
    material: "Matériau",
    defect: "Défaut",
  },
  statistics: {
    riskLevel: {
      title: "Niveau de risque",
    },
    state: {
      title: "État",
    },
  },
  batchEdit: {
    title: "Modification des observations",
    state: {
      optionTitle: "État d'observations",
    },
    severity: {
      optionTitle: "Sévérité d'observations",
    },
  },
  batchEditSelect: {
    selected_one: "observation sélectionnée.",
    selected_other: "observations sélectionnées.",
  },
  batchEditSeverity: {
    formError:
      "Une erreur est survenue lors de la mise à jour des observations. Aucune observation n'a été modifiée.",
  },
  batchTransition: {
    description_one:
      "Veuillez appliquer un nouvel état à l'observation sélectionnée.",
    description_other:
      "Veuillez appliquer un nouvel état aux différentes observations sélectionnées.",
    info: "Les observations complétées et écartées ne peuvent pas être modifiées.",
    formSuccess:
      "Toutes les observations '{{initialState}}' ont été modifiées à l'état '{{newState}}'.",
    formErrorGeneric:
      "Une erreur est survenue lors de la modification des observations '{{initialState}}'.",
    formErrorItems:
      "Les observations suivantes n'ont pas pu être modifiées: {{items}}.",
  },
  validation: {
    validate: "Valider l'observation",
    invalidate: "Invalider",
    user: "Validé par {{name}}",
    date: "Le {{date}}",
  },
  delete: {
    button: "Supprimer l'observation",
    sidePanel: {
      title: "Supprimer l'observation",
      description:
        "Êtes-vous certain de vouloir supprimer l'observation <strong>{{name}}</strong>?",
    },
    relatedItemsDesc:
      "En supprimant l'observation, vous allez supprimer tous les éléments associés:",
    relatedItemsTypes: {
      form: "Informations du formulaire",
      file: "Fichiers",
      gps: "GPS",
      cartesian: "Positionnement cartésien",
      image: "Images",
      planPositioning: "Positionnement sur plan",
      comment: "Commentaires",
      recommendation: "La recommandation",
      interventions: "Interventions recommandées",
    },
  },
};
